<template lang="html">
  <div class="home-articles">
    <h3>
      <span class="home-articles-text">育儿大学</span>
      <!-- <a class='show-more' :href="`/v/articles?ids=${ids}&cmd=share&sharetype=0&refresh=no`">
              <span class="home-article-more" v-if="list && list.length > 5">更多</span>
            </a> -->
    </h3>
    <articleBody :list="list" />
  </div>
</template>

<script>
import articleBody from './articleBody'

export default {
  PAGE_ID: '288987',
  components: {
    articleBody
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    ids: {
      type: String,
      default() {
        return ''
      }
    }
  },
  methods: {
    jump(url) {
      location.href = url
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.home-articles {
  ///margin-bottom: rem(30px);
  // padding-bottom: rem(30px);
  .show-more {
    display: flex;
    align-items: center;
    .home-article-more {
      font-size: rem(24px);
      color: #999;
    }
    //  .icon{
    //     display: inline-block;
    //     height: rem(18px);
    //     width: rem(10px);
    //     margin: 0 0 rem(2px) rem(10px);
    //     background: url('//cmspic-10004025.image.myqcloud.com/a887b720-0205-11ea-98a0-c91677e5da3e_size_9x18') no-repeat center center;
    //     background-size: rem(8px) auto;
    // }
  }
  h3 {
    padding: rem(30px);
    display: flex;
    align-items: center;
    // background: url('https://hzwimspic-1251601690.picsh.myqcloud.com/d6562450-4edd-11ea-a8d7-a9d7fb9b08b4_size_1053x92') no-repeat;
    // background-size: 100% 33px;
    .home-articles-text {
      flex: 1;
      font-size: rem(36px);
      font-weight: 600;
      color: #000;
    }
    a {
    }
    .home-articles-more {
      font-size: rem(24px);
      color: #666666;
    }
    .iconfont {
      display: inline-block;
      color: #666;
      font-size: rem(24px);
      transform: rotate(-90deg);
    }
  }
}
</style>
